__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "digital-library";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@plurall/client", "5.0.19", () => (Promise.all([__webpack_require__.e(1852), __webpack_require__.e(6490), __webpack_require__.e(8444)]).then(() => (() => (__webpack_require__(51852))))));
			register("@plurall/elo-beta", "2.0.0-beta.523", () => (Promise.all([__webpack_require__.e(1854), __webpack_require__.e(318), __webpack_require__.e(676), __webpack_require__.e(8876), __webpack_require__.e(653), __webpack_require__.e(7227)]).then(() => (() => (__webpack_require__(26326))))));
			register("@plurall/reader", "3.0.46", () => (Promise.all([__webpack_require__.e(3624), __webpack_require__.e(318), __webpack_require__.e(676), __webpack_require__.e(8876), __webpack_require__.e(6490), __webpack_require__.e(5657), __webpack_require__.e(5161), __webpack_require__.e(3018)]).then(() => (() => (__webpack_require__(43624))))));
			register("classnames", "2.5.1", () => (__webpack_require__.e(6942).then(() => (() => (__webpack_require__(46942))))));
			register("client-oauth2", "4.3.3", () => (__webpack_require__.e(6710).then(() => (() => (__webpack_require__(26710))))));
			register("date-fns", "2.30.0", () => (Promise.all([__webpack_require__.e(9629), __webpack_require__.e(7451)]).then(() => (() => (__webpack_require__(39629))))));
			register("graphql-tag", "2.12.6", () => (__webpack_require__.e(356).then(() => (() => (__webpack_require__(50356))))));
			register("history", "5.3.0", () => (__webpack_require__.e(7971).then(() => (() => (__webpack_require__(57971))))));
			register("jsencrypt", "3.0.0-rc.1", () => (__webpack_require__.e(7421).then(() => (() => (__webpack_require__(27421))))));
			register("localforage", "1.10.0", () => (__webpack_require__.e(3790).then(() => (() => (__webpack_require__(73790))))));
			register("prop-types", "15.8.1", () => (__webpack_require__.e(5556).then(() => (() => (__webpack_require__(5556))))));
			register("query-string", "6.14.1", () => (__webpack_require__.e(6663).then(() => (() => (__webpack_require__(86663))))));
			register("react-device-detect", "1.17.0", () => (Promise.all([__webpack_require__.e(5042), __webpack_require__.e(318)]).then(() => (() => (__webpack_require__(15042))))));
			register("react-dom", "18.3.1", () => (Promise.all([__webpack_require__.e(961), __webpack_require__.e(318)]).then(() => (() => (__webpack_require__(40961))))));
			register("react-input-mask", "2.0.4", () => (Promise.all([__webpack_require__.e(318), __webpack_require__.e(676), __webpack_require__.e(844)]).then(() => (() => (__webpack_require__(60844))))));
			register("react-router-dom", "6.30.3", () => (Promise.all([__webpack_require__.e(2648), __webpack_require__.e(318), __webpack_require__.e(676)]).then(() => (() => (__webpack_require__(92648))))));
			register("react", "18.3.1", () => (__webpack_require__.e(6540).then(() => (() => (__webpack_require__(96540))))));
			register("whatwg-fetch", "3.6.20", () => (__webpack_require__.e(8624).then(() => (() => (__webpack_require__(78624))))));
			initExternal(69652);
			initExternal(55894);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};